import { CRITICAL_VALUE, END_ANGLE, SHOW_RAY_PROFILE, START_ANGLE, STEP_RAY } from "scripts/api/sector";
import { TableImporter } from "scripts/classes/tableImporter";
import { ERR_NETWORK } from "scripts/ui/components/errors";

const settingsModal = document.getElementById('settings-modal');
if (!(settingsModal instanceof HTMLElement)) { throw new Error("Ошибка ! Модальное окно настроек не найдено")};
export const closeSettingsModal = () => { settingsModal.style.display = 'none'; }

export const initSettings = () => {
    
    const settingsButton = document.getElementById('settings-button') as HTMLInputElement;
    const closeModalBtn = document.getElementById('close-modal') as HTMLInputElement;
    const saveSettingsBtn = document.getElementById('save-settings') as HTMLInputElement;

    // Загрузка сохраненных настроек из localStorage
    loadSettings();

    // Открытие модального окна
    settingsButton.addEventListener('click', () => {
        settingsModal.style.display = 'flex';
    });

    
    // Закрытие модального окна
    closeModalBtn.addEventListener('click', closeSettingsModal);

    // Закрытие при клике вне модального окна
    settingsModal.addEventListener('click', (e) => {
        if (e.target === settingsModal) {
            closeSettingsModal()
        }
    });

    // Сохранение настроек
    saveSettingsBtn.addEventListener('click', () => {
        saveSettings();
        closeSettingsModal()
    });
        
    const tilesBtn = document.getElementById('tiles-btn');
    if (tilesBtn) {
        tilesBtn.style.display = 'inline-block';
        tilesBtn.addEventListener('click', () => {
        showTilesModal();
    });
    }

    new TableImporter();
}
function showTilesModal() {
    const modal = document.getElementById('tilesModal');
    if (!modal) {
        console.error('Модальное окно tilesModal не найдено');
        return;
    }

    if (settingsModal && settingsModal.style.display === 'flex') {
        closeSettingsModal();
    }
    
    modal.style.display = 'flex';
    
    // Закрытие по крестику
    const closeBtn = modal.querySelector('.tiles-modal-close');
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            modal.style.display = 'none';
        });
    }
    
    // Закрытие по кнопке Отмена
    const cancelBtn = document.getElementById('tiles-cancel-btn');
    if (cancelBtn) {
        cancelBtn.addEventListener('click', () => {
            modal.style.display = 'none';
        });
    }
    
    // Закрытие при клике на фон
    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            modal.style.display = 'none';
        }
    });
    
    // Кнопка Скачать с прогресс-баром
    const downloadBtn = document.getElementById('tiles-download-btn');
    if (downloadBtn) {
        // Удаляем старые обработчики
        const newDownloadBtn = downloadBtn.cloneNode(true);
        downloadBtn.parentNode?.replaceChild(newDownloadBtn, downloadBtn);
        
        newDownloadBtn.addEventListener('click', async () => {
            console.log('Кнопка Скачать нажата');
            
            const progressContainer = document.getElementById('tiles-progress-container');
            const progressBar = document.getElementById('tiles-progress-bar');
            const progressPercent = document.getElementById('tiles-progress-percent');
            const progressText = document.getElementById('tiles-progress-text');
            
            // Показываем прогресс-бар
            if (progressContainer) progressContainer.style.display = 'block';
            if (progressBar) progressBar.style.width = '0%';
            if (progressPercent) progressPercent.textContent = '0%';
            if (progressText) progressText.textContent = 'Начинаем скачивание...';
            
            const data = {
                MIN_LAT: parseFloat((document.getElementById('min_lat') as HTMLInputElement)?.value || '43.55'),
                MAX_LAT: parseFloat((document.getElementById('max_lat') as HTMLInputElement)?.value || '43.56'),
                MIN_LON: parseFloat((document.getElementById('min_lon') as HTMLInputElement)?.value || '39.77'),
                MAX_LON: parseFloat((document.getElementById('max_lon') as HTMLInputElement)?.value || '39.78'),
                SAT_MIN_ZOOM: parseInt((document.getElementById('sat_min_zoom') as HTMLInputElement)?.value || '14'),
                SAT_MAX_ZOOM: parseInt((document.getElementById('sat_max_zoom') as HTMLInputElement)?.value || '14'),
                DEM_MIN_ZOOM: parseInt((document.getElementById('dem_min_zoom') as HTMLInputElement)?.value || '14'),
                DEM_MAX_ZOOM: parseInt((document.getElementById('dem_max_zoom') as HTMLInputElement)?.value || '14'),
            };
            
            console.log('=== СКАЧИВАНИЕ TILES ===', data);
            
            if (progressText) progressText.textContent = 'Скачивание тайлов...';
            
            try {
                const response = await fetch('/api/tiles/download', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data)
                });
                
                const result = await response.json();
                
                if (response.ok) {
    console.log('Успешно:', result);
    if (progressBar) progressBar.style.width = '100%';
    if (progressPercent) progressPercent.textContent = '100%';
    if (progressText) progressText.textContent = 'Готово! Обновляем карту...';
    
    // Очищаем кэш браузера для тайлов
    if ('caches' in window) {
        caches.keys().then(keys => {
            keys.forEach(key => {
                if (key.includes('tiles') || key.includes('map') || key.includes('cache')) {
                    caches.delete(key).then(() => console.log('Кэш очищен:', key));
                }
            });
        });
    }
    
    // Принудительная перезагрузка без кэша
    setTimeout(() => {
        window.location.reload();
    }, 1500);
    } else {
                    console.error('Ошибка:', result);
                    if (progressText) progressText.textContent = result?.detail || 'Не удалось скачать тайлы';
                    setTimeout(() => {
                        if (progressContainer) progressContainer.style.display = 'none';
                    }, 2000);
                }
            } catch (error) {
                console.error('Ошибка:', error);
                if (progressText) progressText.textContent = ERR_NETWORK;
                setTimeout(() => {
                    if (progressContainer) progressContainer.style.display = 'none';
                }, 2000);
            }
        });
    }
}

const importTableBtn = document.getElementById('txt-import-btn');
if (importTableBtn) {
    importTableBtn.addEventListener('click', () => {
        showImportTableModal();
    });
}

function showImportTableModal() {
    const modal = document.getElementById('importTableModal');
    if (!modal) {
        console.error('Модальное окно importTableModal не найдено');
        return;
    }
    
    // Закрываем окно настроек
    if (settingsModal && settingsModal.style.display === 'flex') {
        closeSettingsModal();
    }
    
    modal.style.display = 'flex';
    
    // Сбрасываем статус и файл
    const fileInput = document.getElementById('importTableFileInput') as HTMLInputElement;
    const statusDiv = document.getElementById('importTableStatus');
    if (fileInput) fileInput.value = '';
    if (statusDiv) statusDiv.style.display = 'none';
    
    // Кнопка Отмена (исправлено - удаляем старый обработчик и добавляем новый)
    const cancelBtn = document.getElementById('importTableCancelBtn');
    if (cancelBtn) {
        const newCancelBtn = cancelBtn.cloneNode(true);
        cancelBtn.parentNode?.replaceChild(newCancelBtn, cancelBtn);
        newCancelBtn.addEventListener('click', () => {
            modal.style.display = 'none';
        });
    }
    
    // Кнопка Скачать пример
    const downloadExampleBtn = document.getElementById('importTableDownloadExampleBtn');
    if (downloadExampleBtn) {
        const newDownloadBtn = downloadExampleBtn.cloneNode(true);
        downloadExampleBtn.parentNode?.replaceChild(newDownloadBtn, downloadExampleBtn);
        newDownloadBtn.addEventListener('click', () => {
            // Скачиваем файл примера с сервера
            window.location.href = '/api/muon-table-txt/download-example';
        });
    }
    
    // Кнопка Прикрепить
const confirmBtn = document.getElementById('importTableConfirmBtn');
if (confirmBtn) {
    const newConfirmBtn = confirmBtn.cloneNode(true);
    confirmBtn.parentNode?.replaceChild(newConfirmBtn, confirmBtn);
    
    newConfirmBtn.addEventListener('click', async () => {
        const file = fileInput?.files?.[0];
        if (!file) {
            showImportStatus('Выберите файл!', 'error');
            return;
        }
        
        showImportStatus('Проверка файла...', 'info', true);
        
        try {
            const formData = new FormData();
            formData.append('file', file);
            
            // 1. Проверяем файл
            const response = await fetch('/api/muon-table-txt/validate', {
                method: 'POST',
                body: formData
            });
            
            const result = await response.json();
            
            if (result.is_valid) {
                // 2. Спрашиваем подтверждение
                const userConfirmed = confirm(result.message + '\n\nСохранить файл?');
                
                if (userConfirmed) {
                    showImportStatus('Сохранение...', 'info', true);
                    
                    // 3. Сохраняем файл
                    const saveResponse = await fetch('/api/muon-table-txt/save', {
                        method: 'POST'
                    });
                    const saveResult = await saveResponse.json();
                    
                    if (saveResponse.ok) {
                        showImportStatus(saveResult.message, 'success');
                        setTimeout(() => {
                            modal.style.display = 'none';
                        }, 2000);
                    } else {
                        showImportStatus(saveResult?.detail || 'Не удалось сохранить таблицу', 'error');
                    }
                } else {
                    showImportStatus('Сохранение отменено', 'info');
                    setTimeout(() => {
                        modal.style.display = 'none';
                    }, 1500);
                }
            } else {
                let errorMsg = '❌ Файл не соответствует структуре!\n';
                if (result.checks) {
                    if (!result.checks.has_muon_header) errorMsg += '• Отсутствует заголовок Muon\n';
                    if (!result.checks.has_standard_rock) errorMsg += '• Отсутствует "standard rock"\n';
                    if (!result.checks.has_density) errorMsg += '• Отсутствует плотность\n';
                    if (!result.checks.has_table_header) errorMsg += '• Отсутствует таблица\n';
                }
                showImportStatus(errorMsg, 'error');
            }
        } catch (error) {
            showImportStatus(ERR_NETWORK, 'error');
        }
    });
}
    
    // Закрытие при клике на фон
    modal.onclick = (e) => {
        if (e.target === modal) {
            modal.style.display = 'none';
        }
    };
}

function showImportStatus(message: string, type: 'success' | 'error' | 'info', withProgress: boolean = false) {
    const statusDiv = document.getElementById('importTableStatus');
    if (!statusDiv) return;
    
    statusDiv.style.display = 'block';
    
    let bgColor = type === 'success' ? '#1a5c3a' : (type === 'error' ? '#b92525' : '#3c98ee');
    statusDiv.style.backgroundColor = bgColor;
    statusDiv.style.color = '#fff';
    statusDiv.style.padding = '10px';
    statusDiv.style.borderRadius = '8px';
    
    if (withProgress) {
        statusDiv.innerHTML = `<div style="display: flex; align-items: center; gap: 10px;">
            <div style="flex:0 0 auto; box-sizing:border-box; width: 20px; height: 20px; border: 2px solid #fff; border-top-color: transparent; border-radius: 50%; animation: spin 1s linear infinite;"></div>
            <span>${message}</span>
        </div>`;
    } else {
        statusDiv.innerHTML = message;
    }
    
    if (type !== 'error' && !withProgress) {
        setTimeout(() => {
            statusDiv.style.display = 'none';
        }, 3000);
    }
}

    // Сохранение настроек (в localStorage)
function saveSettings() {
    try {
        const criticalValueInput = document.getElementById('critical-value') as HTMLInputElement;
        const startAngleInput = document.getElementById('startAngleInput') as HTMLInputElement;
        const endAngleInput = document.getElementById('endAngleInput') as HTMLInputElement;
        const stepRayInput = document.getElementById('stepRayInput') as HTMLInputElement;

        // критическое значение должно быть целым числом (метры)
        const cv = parseInt(criticalValueInput.value, 10);
        if (isNaN(cv) || cv <= 0) {
            alert('Критическая точка должна быть числом (метры) > 0');
            return;
        }
        // (если вам нужно требовать >=800 — верните эту проверку)
        localStorage.setItem(CRITICAL_VALUE, cv.toString());

        // Сохраняем углы/шаг (если заполнены)
        if (startAngleInput && startAngleInput.value !== '') {
            localStorage.setItem(START_ANGLE, startAngleInput.value);
        } else {
            localStorage.removeItem(START_ANGLE);
        }
        if (endAngleInput && endAngleInput.value !== '') {
            localStorage.setItem(END_ANGLE, endAngleInput.value);
        } else {
            localStorage.removeItem(END_ANGLE);
        }
        if (stepRayInput && stepRayInput.value !== '') {
            localStorage.setItem(STEP_RAY, stepRayInput.value);
        } else {
            localStorage.removeItem(STEP_RAY);
        }

        const showRayProfileInput = document.getElementById('show-ray-profile') as HTMLInputElement;
        localStorage.setItem(SHOW_RAY_PROFILE, showRayProfileInput.checked.toString());

        console.log('Настройки сохранены:', {
            criticalValue: localStorage.getItem(CRITICAL_VALUE),
            startAngle: localStorage.getItem(START_ANGLE),
            endAngle: localStorage.getItem(END_ANGLE),
            stepRay: localStorage.getItem(STEP_RAY)
        });
    } catch (error) {
        console.error('Ошибка при сохранении настроек:', error);
        alert('Произошла ошибка при сохранении настроек');
    }
}

// Загрузка настроек (вызывается при старте)
function loadSettings() {
    try {
        const criticalValueInput = document.getElementById('critical-value') as HTMLInputElement;
        const startAngleInput = document.getElementById('startAngleInput') as HTMLInputElement;
        const endAngleInput = document.getElementById('endAngleInput') as HTMLInputElement;
        const stepRayInput = document.getElementById('stepRayInput')  as HTMLInputElement;

        const criticalValue = localStorage.getItem(CRITICAL_VALUE);
        const startAngle = localStorage.getItem(START_ANGLE);
        const endAngle = localStorage.getItem(END_ANGLE);
        const stepRay = localStorage.getItem(STEP_RAY);

        if (criticalValue) {
            criticalValueInput.value = criticalValue;
        }
        if (startAngle) startAngleInput.value = startAngle;
        if (endAngle) endAngleInput.value = endAngle;
        if (stepRay) stepRayInput.value = stepRay;

        const showRayProfileInput = document.getElementById('show-ray-profile') as HTMLInputElement;
        showRayProfileInput.checked = localStorage.getItem(SHOW_RAY_PROFILE) === 'true';

    } catch (error) {
        console.error('Ошибка при загрузке настроек:', error);
    }
}